import React, { Component } from 'react';

import Navigation from './Navigation'
import Cart from './Cart'

var Page1 = require('./Page1');
var Page2 = require('./Page2');
var Page3 = require('./Page3');
var styles = require('../global.scss');
var logo = require('../img/logo.png');

var apiBookUrl = process.env.NODE_ENV == 'dev'
    ? '/api/api.json'
    : 'praia/api/price';

var App = React.createClass({

    getInitialState: function() {
        return {
            priceData: null,
            bookingData: null,
            showCart: true,
            showPage1: true,
            showPage2: false,
            showPage3: false,
            page2processing: false,
            competitionOrigin : 'sv',
            totalPrice: 'SEK 0'
        }
    },
    render: function () {
       return (
           <div>
               <Navigation totalPrice={this.state.totalPrice} onClick={this.handleTotalClick} />
               <Cart data={this.state.priceData} visible={this.state.showCart} />
               <img src={logo} className={styles.logo} alt="BeachTravels logo" />
               <Page1 onChange={this.getPriceCalculation} visible={this.state.showPage1} />
               <Page2 values={this.state.bookingData} onChange={this.handleClick} visible={this.state.showPage2}
                      processing={this.state.page2processing} />
               <Page3 origin={this.state.competitionOrigin} visible={this.state.showPage3} />
               <footer className="wrapper-640">
                   <div>
                       <div>
                           About us: <br/>
                           BeachTravels Sweden AB <br/>
                           VAT: SE556863312601
                       </div>
                       <div>
                           Hansavägen 10 <br/>
                           15138 Sodertalje <br/>
                           Sweden
                       </div>
                   </div>
               </footer>
           </div>


       )
    },
    getPriceCalculation: function(data) {
        if (!data.visible) {
            this.setState({
                bookingData: data,
                competitionOrigin: data.travelData.country,
                showPage2: true,
                showPage1: false
            });
        }

        if (data.travelData.country == '' || data.travelData.duration == ''){
            return;
        }

        var self = this;
        var request = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                Country: data.travelData.country,
                Airport: data.travelData.airport,
                Direct: data.travelData.direct,
                Package: data.travelData.package,
                AllIn: data.travelData.allIn,
                AllInWeek: data.travelData.allInWeek,
                Duration: data.travelData.duration,
                Accommodation: data.travelData.accommodation,
                SeaView: data.travelData.seaView,
                Transfer: data.travelData.transfer,
                Insurance: data.travelData.insurance,
                Team: data.travelData.team,
                Surf: data.travelData.surf,
                Discount: data.travelData.discount,
                Kids: data.travelData.kids,
                KidsWeek: data.travelData.kidsWeek,
            })
        };

        if (process.env.NODE_ENV == 'dev') {
            request = {
                method: 'GET'
            }
        }

        fetch(apiBookUrl, request).then(function(response) {
            return response.json();
        }).then(function(json) {
            var result = json;
            console.log(result);
            self.setState({
                priceData: result,
                showCart: true,
                totalPrice: result.TotalPrice
            });
        }).catch(function(err) {
            console.log(err)
        });
    },
    handleTotalClick : function (showCart) {
        this.setState({
            showCart: showCart
        });
    },
    handleClick: function (data) {
        if (data.action == 'back') {
            this.setState({
                showPage1: true,
                showPage2: false
            });
        } else {
            var self = this;
            var bookingData = this.state.bookingData;
            this.setState({
                page2processing: true,
            }, function () {
                fetch('praia/api/application', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        Origin: bookingData.travelData.country,
                        Airport: bookingData.travelData.airport,
                        Direct: bookingData.travelData.direct,
                        Package: bookingData.travelData.package,
                        AllIn: bookingData.travelData.allIn,
                        AllInWeek: bookingData.travelData.allInWeek,
                        Kids: bookingData.travelData.kids,
                        KidsWeek: bookingData.travelData.kidsWeek,
                        Duration: bookingData.travelData.duration,
                        Accommodation: bookingData.travelData.accommodation,
                        SeaView: bookingData.travelData.seaView,
                        Transfer: bookingData.travelData.transfer,
                        Insurance: bookingData.travelData.insurance,
                        Team: bookingData.travelData.team,
                        Surf: bookingData.travelData.surf,
                        Discount: bookingData.travelData.discount,
                        FirstName: bookingData.personData.firstname,
                        SurName: bookingData.personData.surname,
                        Gender: bookingData.personData.gender,
                        BirthDate: bookingData.personData.birth.substring(2),
                        Email: bookingData.personData.email,
                        Address: bookingData.personData.address,
                        ZipCode: bookingData.personData.zipcode,
                        City: bookingData.personData.city,
                        Country: bookingData.personData.country,
                        Phone: bookingData.personData.phone,
                        OtherInformation: bookingData.personData.other

                    })
                }).then(function(response) {
                    return response.json();
                }).then(function(json) {
                    console.log('parsed json', json);
                    self.setState({
                        showPage1: false,
                        showPage2: false,
                        showPage3: true
                    });
                }).catch(function(err) {
                    console.log(err)
                });
            });

        }

    }
});

module.exports = App;


// WEBPACK FOOTER //
// ./app/components/App.js